export default {
	unitName: "GoogleButton",
	onConnected: async function(){
		console.log("ONCONNECTED")

		this.obs = midflip.mob(this.el, (() => {
			console.log("OBS HIT")
			let fr = this.el.qs('iframe')
			if(fr.getAttribute('style').includes('-2px -10px;')){
				fr.setAttribute('style',
					(fr.getAttribute('style').
						split(';').
						filter((a) => {
							return !(a.includes('width') || a.includes('margin'))
						}).
						join(';')
					) + `; width: ${parseInt(this.el.dataset.width) + 20}px; margin: -2px -10px 0px 0px;`
				)
			}
		}).bind(this))

		await midflip.getGoogle()
		console.log("GOT GOOG")

		let client_id = document.head.querySelector('[name="google_client"]').content
		let login_url = document.head.querySelector('[name="google_login_url"]').content

		//setup google login settings
		// google.accounts.id.initialize({
		// 	client_id: client_id,
		// 	callback: (x) => {
		// 		let credential = x.credential
		// 		otty.dive({url: login_url, formInfo: {credential}})
		// 	},
		// 	auto_prompt: "false"
		// });

		let out = google.accounts.id.renderButton( this.el,  {
			theme: "outline",
			width: parseInt(this.el.dataset.width),
			type: "standard",
			size: "large",
			theme: "outline",
			text: "sign_in_with",
			shape: "rectangular",
			logo_alignment: "left"
		});
		console.log("REND", out)
	},
	onRemoved(){
		console.log("DISCON")
		if(this.obs){this.obs.disconnect()}
		this.el.innerHTML = ''
	}
}